// extracted by mini-css-extract-plugin
module.exports = {"section":"social_impact_section__khXb_","sub_title":"social_impact_sub_title__3nIcU","main":"social_impact_main__z1b55","cta":"social_impact_cta__zKkl7"};